"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLocalAppFlowDocId = buildLocalAppFlowDocId;
exports.parseAppFlowDocId = parseAppFlowDocId;
function part(value) {
    if (!value || value.includes('$'))
        throw new Error('Invalid App Flow document ID part');
    return value;
}
function buildLocalAppFlowDocId(target) {
    const { version } = target;
    if (version !== undefined && (!Number.isSafeInteger(version) || version < 1))
        throw new Error('Invalid App Flow version');
    return [
        'db',
        'appflow',
        part(target.appBaseId),
        part(target.appId),
        version === undefined ? 'draft' : String(version),
    ].join('$');
}
function parseAppFlowDocId(docId, workspaceId) {
    const parts = docId.split('$');
    if (parts.length !== 6)
        return null;
    const [prefix, workspace, kind, appBaseId, appId, selection] = parts;
    if (prefix !== 'db' ||
        !workspaceId ||
        workspace !== workspaceId ||
        kind !== 'appflow' ||
        !appBaseId ||
        !appId)
        return null;
    if (selection === 'draft')
        return { appBaseId, appId };
    const version = Number(selection);
    if (!Number.isSafeInteger(version) ||
        version < 1 ||
        String(version) !== selection)
        return null;
    return { appBaseId, appId, version };
}
